import { Box, Typography } from "@mui/material";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import { AddressMapData } from "../maps-feature/AddressMapProvider";

export interface AddressMapProps {
  mapData?: AddressMapData | null;
  isLoading?: boolean;
  isError?: boolean;
}

const MAP_HEIGHT = 200;

export default function AddressMap({
  mapData,
  isLoading = false,
  isError = false,
}: Readonly<AddressMapProps>) {
  if (isLoading) {
    return (
      <Box
        sx={{
          height: MAP_HEIGHT,
          bgcolor: "grey.100",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 1,
        }}
      >
        <Typography variant="body2" color="text.disabled">
          Loading map...
        </Typography>
      </Box>
    );
  }

  if (isError || !mapData?.mapSasUrl) {
    return (
      <Box
        sx={{
          height: MAP_HEIGHT,
          bgcolor: "grey.100",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 1,
        }}
        aria-label="Map unavailable"
      >
        <PlaceOutlinedIcon sx={{ fontSize: 40, color: "text.disabled" }} />
        <Typography variant="body2" color="text.disabled" sx={{ mt: 1 }}>
          Map unavailable
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: MAP_HEIGHT, width: "100%", borderRadius: 1, overflow: "hidden" }}>
      <img
        src={mapData.mapSasUrl}
        alt="Address map"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
      />
    </Box>
  );
}
